<template>
  <main>
    <div class="Gameproblem">
      <Tou></Tou>
      <div class="GP_all">
        <div class="title gpconente">
          <!-- <div>您在哪一款产品中遭遇到困难?</div> -->
        </div>
        <ul class="routing">
          <li>
            <span @click="Instructions_ER" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">账户常见问题</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="gpconente niceall">
          <li>
            <router-link :to="{ path: `/What` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                账号登陆不上怎么办
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Vip` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                Vip权益
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/VipCashback` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                VIP邀请返现说明
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/free` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                海星云免费游戏
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/cloud` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                关于云存档
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/save` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                游戏怎么存档
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Configuration` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                海星云配置
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/Nogames` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                没有游戏怎么办
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/friend` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                如何找到其他海星云小伙伴
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: `/ButtonTutorial` }">
              <div class="gpclink">
                <div class="lefttou"></div>
                Android/IOS客户端按键教程
                <div class="triangles"></div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {
  },
  methods: {
    height_game () {
      // this.$refs.game
    },
    Instructions_ER () {
      this.$router.push('./faq')
    }
  }
}
</script>

<style lang="scss" scoped>
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
html,
body {
  height: 100%;
  width: 100%;
}
.GP_all {
  padding-top: 160px;
  padding-bottom: 35px;
  background-color: #100e2e;
}
.Gameproblem {
  height: 100vh;
  background-color: #100e2e;
  box-sizing: border-box;
}
.title {
  font-size: 18.3px;
  color: #5eafde;
  background-color: transparent !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.gpconente {
  width: 1070px;
  margin: 0 auto;
  // border: 1px solid red;
  background-color: #0d0b26;
  padding-top: 30px;
  overflow: hidden;
  padding-bottom: 40px;
  margin-top: 15px;
}
.gpconente li {
  width: 712px;
  margin: 15px auto;
  height: 44px;
  text-indent: 25px;
  cursor: pointer;
  background-color: #445468;
  font-size: 16px;
  line-height: 44px;
  user-select: none;
  transition-duration: 0.3s;
}
.gpconente li:hover {
  background: rgba(68, 84, 104, 0.6);
  color: white;
}
@media screen and (min-width: 349px) and (max-width: 1000px) {
  .GP_all {
    padding-top: 0;
  }
  .niceall {
    width: 100%;
    // height: 520px;
    // overflow-y: auto;
  }
  .gpconente li {
    width: 80%;
    font-size: 14px;
  }
}
@media screen and (max-width: 349px) {
  .GP_all {
    padding-top: 0;
  }
  .niceall {
    width: 100%;
    height: 450px;
    overflow-y: auto;
    padding-bottom: 80px;
  }
  .gpconente li {
    width: 80%;
    font-size: 14px;
  }
}
.gpclink {
  color: white !important;
}
.gpclink:hover {
}
.lefttou {
  height: 44px;
  width: 3px;
  float: left;
  background-color: transparent;
}
.gpconente li:hover .lefttou {
  background-color: #f4c91d;
}
.triangles {
  float: right;
  margin-right: 15px;
  width: 0;
  height: 0;
  border-width: 8px 0px 8px 16px;
  border-style: solid;
  border-color: transparent transparent transparent #a0b3cb;
  margin-top: 14px;
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}

.Instructions:hover {
  color: white;
  cursor: pointer;
}

@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
    margin-top: 45px;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .GP_all {
    padding-top: 180px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .GP_all {
    padding-top: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/Account.vue